import { SimpleHandler } from './../../../types/handlers';
import { ModalLoginHandler, ModalLoginInfo } from './../../../types/modal-login-message';
import { ModalMessagerService } from './../../../components/dialogs/modal-messager/modal-messager.service';
import { AnyHandler } from 'app/types/handlers';
import { Injectable, Inject, InjectionToken } from '@angular/core';
import { HttpInterceptor, HttpClient, HttpHeaders, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { Subscription, Observable } from 'rxjs';
import { Dict, Decorable } from 'app/types/decorable';
import { CookieService } from 'ngx-cookie-service';
import { EnvService } from 'app/env.service';
import { environment } from 'app/../environments/environment';
import { CancellablePromise } from 'app/types/cancellable-promise';
import { timeout } from 'rxjs/operators';
import { InterruptableTimer } from 'app/model/interruptable-timer';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);
    return next.handle(req).pipe(timeout(timeoutValueNumeric));
  }
}
@Injectable({
  providedIn: 'root'
})
export class ServerService {
  static ServerSESSION: Dict | null = null;
  private areYouThereTimer?: InterruptableTimer;
  private logoutTimer?: InterruptableTimer;
  private sessionCheck_ms = 3600000; // one hour idle check
  private notThereCheck_ms = 300000; // five minute are you there message
  private baseURL: string;
  private appName: string;
  private session: Dict | null = null;
  private unauthSession?: Dict;
  private authTo: string;
  private tabsReady = true;

  private static SetServerSession(session: Dict) {
    ServerService.ServerSESSION = session;

  }
  private static ClearSession() {
    ServerService.ServerSESSION = null;
  }
  constructor(private http: HttpClient, private cookies: CookieService, private env: EnvService, private messager: ModalMessagerService) {
    this.appName = 'main-app';
    this.baseURL = environment.serverURL;
    this.authTo = '/';
    this.tabsReady = this.tabsReady;
    this.areYouThereTimer = new InterruptableTimer();
    this.logoutTimer = new InterruptableTimer();
  }

  Post(
    serverURL: string, payLoad: Decorable, asJSON: boolean = true): CancellablePromise {
    this.logoutTimer?.Stop();
    this.areYouThereTimer?.Stop();
    const token = this.GetToken();
    if (!!token) {
      payLoad.token = this.GetToken();
    }
    payLoad.context = this.appName;
    if (asJSON) {
      payLoad.format = 'json';
    }
    const postData = new FormData();
    for (const key of Object.keys(payLoad)) {
      if (typeof payLoad[key] === 'object') {
        postData.append(key, JSON.stringify(payLoad[key]));
      } else {
        postData.append(key, payLoad[key]);
      }
    }
    let subscription: Subscription;
    const promise: Promise<any> = new Promise((resolve, reject) => {
      subscription = this.http.post(this.baseURL + serverURL, postData, { withCredentials: true }).pipe().subscribe(
        (data: any) => {
          if (data === null) {
            let params = '';
            for (const key in postData) {
              var val: FormDataEntryValue | null = postData.get(key);
              if (!val) { continue; }
              params += '/' + key + ':' + val + '/';
            }
            reject({ problem: 'null data', url: this.baseURL + serverURL, postParams: params, postedData: postData });
            return;
          }
          if (data.hasOwnProperty('json')) {
            data = data.json;
          }
          if (!!data.response) {
            data = data.response;
          }

          if (data.status) {
            if (data.status !== 'ok') {
              if (data.message === 'auth required') {
                this.Login(() => {
                  const handler = resolve;
                  this.Post(serverURL, payLoad, asJSON).then((response) => {
                    handler(response);
                  });
                });
                return;
              }
              reject(new Error(data.status));
              return;
            }
          }
          if (data.etoken) {
            if ((Number(data.etoken) * 1000) < Date.now().valueOf()) {
              this.Login();
            } else {
              this.areYouThereTimer?.Interrupt(true);
              this.logoutTimer?.Stop();
            }
          }
          resolve(data);
          subscription.unsubscribe();
        },
        error => {
          reject(error);
          subscription.unsubscribe();
        }
      );
    }).catch((error) => {
      const isProduction = this.env.GetEnvParam('production');
      if (!isProduction) {
        console.log('Request Error', error);
      }
    }).finally(() => { });
    (promise as CancellablePromise).abort = () => {
      if (!!subscription) {
        subscription.unsubscribe();
      }
    };
    return promise as CancellablePromise;
  }

  SetAppName(appName: string): void {
    this.appName = appName;
  }
  Authenticate(identity: string, pw: string): Promise<any> {

    return this.GetAuthPromise({ identity: identity, password: pw });
  }
  Login(handler?: ModalLoginHandler) {
    const token = this.cookies.get('localsession');
    if (token) {
      this.GetAuthPromise({ token: (token) }).then((loginInfo: ModalLoginInfo) => {
        if (handler) {
          handler(loginInfo);
        }
      }).catch(() => {
        this.messager.Login((params: ModalLoginInfo) => {
          if (!!handler) handler(params);
        });
      });

    } else {
      this.messager.Login((params: ModalLoginInfo) => {
        if (!!handler) handler(params);
      });
    }


  }
  GetAuthPromise(params: Dict): Promise<any> {
    return new Promise((resolve, reject) => {
      const asVisitor: boolean = (!!params.isPublic) ? params.isPublic : false;
      if (asVisitor === false) {
        if (params.token === null) {
          reject('no token');
          return;
        }
      }
      if (this.appName === '') { reject(); return; }
      const body: URLSearchParams = new URLSearchParams();
      if (params.hasOwnProperty('identity')) {
        body.set('identity', params.identity);
      }
      if (params.hasOwnProperty('password')) {
        body.set('password', params.password);
      }
      if (params.hasOwnProperty('token')) {
        body.set('token', params.token);
      }
      body.set('context', this.appName);
      const options = {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
      };
      this.http.post(
        this.baseURL + 'contact/authenticate', body.toString(), options
      ).subscribe(
        (data: any) => {
          if (data.hasOwnProperty('json')) {
            data = data.json;
          }
          if (!data.response) return;
          const response = data.response;
          if (!!response.status) {
            if (response.status !== 'ok') {
              reject(response);
              return;
            }
          }
          if (response.hasOwnProperty('token')) {
            const expires = new Date(Number(response.expires) * 1000);
            const secure = !this.env.GetEnvParam('local');
            this.session = response;
            const expireTime = new Date(Date.now().valueOf() + this.sessionCheck_ms + this.notThereCheck_ms); //this. expires.toLocaleTimeString();
            const expireMessage = `Idle session detected. Press OK to stay logged in, or cancel to logout. You will automatically be logged out at ${expireTime}`;
            const expireTitle = 'Idle session detected';
            if (this.areYouThereTimer) {
              this.areYouThereTimer.Start(() => {
                this.logoutTimer?.Start(() => {
                  this.messager.Cancel(expireTitle);
                  this.Unauthenticate().then(() => {
                    this.Login();
                  });
                }, this.notThereCheck_ms);
                this.messager.Confirm(expireMessage, () => {
                  this.PreserveSession();
                }, () => {
                  this.Unauthenticate().then(() => {
                    this.Login();
                  });
                }, expireTitle);
              }, this.sessionCheck_ms);
            }
            if (this.env.GetEnvParam('local') === true) {
              const token = this.GetToken();
              this.cookies.set('localsession', token ? token : '', undefined, '/', undefined, undefined, 'Lax');
            }
            ServerService.SetServerSession(this.session as Dict);
          }
          resolve(response);
        },
        error => reject(error)
      );
    });
  }
  Logout(handler?: SimpleHandler, cancelHandler?: SimpleHandler) {
    this.messager.Logout(() => {
      this.Unauthenticate().then(() => {
        if (!!handler) handler();
      }).catch(() => {
        if (!!cancelHandler) cancelHandler();
      })
    });
  }
  Unauthenticate(): Promise<Decorable> {
    return new Promise((resolve, reject) => {
      if (this.appName === '') { reject(); return; }
      const body: URLSearchParams = new URLSearchParams();
      const token = this.GetToken();
      body.set('token', !!token ? token : '');
      body.set('context', this.appName);
      body.set('format', 'json');
      const options = {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      };
      this.UnsetSession();
      this.http.post(
        this.baseURL + 'contact/logout', body.toString(), options
      ).subscribe(
        (data: any) => {
          resolve(data);
        },
        error => reject(error)
      );
    });
  }
  SetAuthTo(where: string): void {
    this.authTo = decodeURI(where);
  }
  GetAuthTo(): string {
    return this.authTo;
  }
  HasSession(): boolean {
    return !!this.session && this.session !== null;
  }
  GetSession(): Dict | null {
    if (this.HasSession()) {
      return this.session as Dict;
    }
    return null;
  }
  GetToken(isPublic?: boolean): string | null {
    if (!this.session) return null;
    if (!!this.session.token) {
      return this.session.token;
    }
    return null;
  }
  PreserveSession() {
    this.logoutTimer?.Stop();
    this.areYouThereTimer?.Stop();
    const postData = new FormData();
    const token = this.GetToken();
    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    };
    if (!!token) {
      postData.append('token', token);
      postData.append('context', this.appName);
    }
    this.http.post(
      this.baseURL + 'ping', postData.toString(), options
    ).subscribe((data: any) => {
      if (!!data.response && !!data.response.token) {
        this.session = data.response;
      }
    });
  }
  IsAuthenticated(): boolean {
    return this.HasSession();

  }
  UnsetSession(): void {
    this.session = null;
    ServerService.ClearSession();
  }
  DownloadFile(serverURL: string, payLoad: Decorable, mimeType: string, fileName: string, responseHandler?: AnyHandler) {
    const postData = new FormData();
    for (const key of Object.keys(payLoad)) {
      postData.append(key, payLoad[key]);
    }
    const token = this.GetToken();
    if (token) {
      postData.append('token', token);
    }
    this.http.post(this.baseURL + serverURL,
      postData,
      {
        responseType: 'blob',
      }
    ).subscribe((response) => {
      const blob = new Blob([response], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      if (!!responseHandler) {
        responseHandler({ url: (url), fileName: (fileName) });

      } else {
        const a = document.createElement('a');
        a.title = 'fileName';
        a.href = url;
        a.download = fileName;
        a.innerHTML = 'download';
        window.document.body.append(a);
        a.click();
        a.remove();
      }

    });
  }
  GetServerURL(relPath: string, includeToken: boolean = false): string {
    let url = this.baseURL;
    url += relPath;
    return url;
  }

}
